import { EmptyState } from "@backstage/core-components"
import { CardContent } from "@material-ui/core"

export const PermissionDeniedCard = ({ className }: { className: string }) => {
  return (
    <CardContent className={className}>
      <EmptyState
        title='Permission Denied'
        description='Sorry! You do not have permission to view this card. If you believe this is a mistake contact the DeveloperServices team.'
        missing='info'
      />
    </CardContent>
  )
}

export const NotFoundCard =({ className }: { className: string}) => {
  return (
  <CardContent className={className}>
      <EmptyState
        title='Not Found'
        description='Sorry! We do not have information for this component; Please ensure you are on the latest charts. If this persists please contact the DeveloperServices team'
        missing='info'
      />
    </CardContent>
  )
}
